import { useEffect } from 'react'
import { Icon } from '../common/icons'
import Aux from '../hoc/auxiliary'
import { ProductFile } from './productFile';
import { isNullOrWhiteSpace } from '../../helpers/isNullOrWhiteSpace'
import parse from 'html-react-parser';

export const ProductFileResource = ({
  product,
  getUrlWithSas,
  urlWithSas,
  loadingUrlWithSas,
  downloadResource,

}) => {

    useEffect(() => {

        getUrlWithSas()
    }, [])
  
    const upperCasePublisherName = product.publisher

    return(

      <Aux>
      {product && <ProductFile product={product} urlWithSas={urlWithSas} loadingUrlWithSas={loadingUrlWithSas} />}

<div className="gpt-message__product--contents-info">
<div>
<div className="gpt-message__product--contents-info-title">
<div style={{display: 'flex', gap: '2rem'}}>
<div className="ai-body-large ai-grey-100">{product.title}</div>
<div className="gpt-message__product--contents-options">
<div>
       
  
      <div className="gpt-message__product--contents-option" onClick={() => downloadResource(product)}>
           <Icon name="download" customClass="icon--normal" />
       </div>
   </div>
   </div>
   </div>
{product.publisher &&
   <div>
       <img
           src={product.publisherAvatarUrl}
           alt={product.publisher}

       />
       <div className="ai-body-tiny ai-grey-80">{upperCasePublisherName}</div>
   </div>
}
   </div>
<div className=" gpt-message__product--contents-description" style={{display: 'flex', flexDirection: 'column', gap: '2rem'}}>
    {product.completionExplanation &&
   <div>
   <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '1.2rem'}}>
        <div className="ai-body-medium bold ai-grey-100">Standard Coverage</div>
        <div className="ai-body-tiny ai-grey-80" style={{display: 'flex', alignItems: 'center', gap: '0.4rem'}}>
                <Icon name="stars" customClass="icon--medium" />
                <div className="ai-body-tiny ai-grey-80">AI generated</div>
            </div>
        </div>
       <div className="ai-body-medium ai-grey-100">{product.completionExplanation}</div>
   </div>
}
{product.generatedDescription && !isNullOrWhiteSpace(product.generatedDescription) && 
   <div>
    <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '1.2rem'}}>
        <div className="ai-body-medium bold ai-grey-100">Description</div>
        <div className="ai-body-tiny ai-grey-80" style={{display: 'flex', alignItems: 'center', gap: '0.4rem'}}>
                <Icon name="stars" customClass="icon--medium" />
                <div className="ai-body-tiny ai-grey-80">AI generated</div>
            </div>
        </div>
       <div className="ai-body-medium ai-grey-100">{product.generatedDescription && !isNullOrWhiteSpace(product.generatedDescription) ? parse(product.generatedDescription) : product.description && !isNullOrWhiteSpace(product.description) ? parse(product.description) : ''}</div>
   </div>
}
   </div>


</div>

</div>
                      </Aux>
      
    )


}

